import styled from "styled-components";
import Dialog from "../../../../../../components/dialog/dialog";

export const AddLinkModalStyled = styled(Dialog)`
  width: 70%;
  height: auto;
  .body {
    padding: 16px;
  }

  .heading {
    gap: 7px;
    display: grid;
  }

  .form {
    margin-top: 16px;
    display: grid;
    gap: 8px
  }

  .MuiPaper-root {
    max-height: 390px;
    padding: 0;
  }
`;
